import React, { useState, useEffect } from 'react';
import Form from './Form';
import Text from './Text';

const SumUpPayment = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [affiliateKey, setAffiliateKey] = useState('');

  useEffect(() => {
    checkLoginStatus();
    setAffiliateKey(window.RUNTIME_CONFIG?.SUMUP_KEY || '');
    window.onSumUpLoginSuccess = () => {
      setIsLoggedIn(true);
    };

    window.onSumUpLoginError = () => {
      setIsLoggedIn(false);
    };


    return () => {
      // Cleanup
      delete window.onSumUpLoginSuccess;
      delete window.onSumUpLoginError;
      delete window.onSumUpPaymentSuccess;
      delete window.onSumUpPaymentError;
    };
  }, []);

  const checkLoginStatus = () => {
    if (window.AndroidBridge) {
      setIsLoggedIn(window.AndroidBridge.isLoggedIn());
    }
  };

  const handleLogin = () => {
    if (window.AndroidBridge) {
      if (affiliateKey) {
        window.AndroidBridge.loginSumUp(affiliateKey);
      }
    } 
  };

  const handleLogout = () => {
    if (window.AndroidBridge) {
      window.AndroidBridge.logout();
      setIsLoggedIn(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isLoggedIn) {
      handleLogout();
    } else {
      handleLogin();
    }
  };

  return (
    window.AndroidBridge ? (
      <Form onSubmitAction={(e) => handleFormSubmit(e)} submitButtonText={isLoggedIn ? "Von SumUp Trennen" : 'Mit SumUp verbinden'} />
    ) : (<div>
      <Text type="maintitle" classNames={"w-full flex text-gray-400"} >SumUp Integration nur auf Android App möglich</Text>
    </div>)

  );
};

export default SumUpPayment;